import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import {useRouter} from '@uirouter/react'
import {refreshHomeStats, TotalsAC} from 'redux/totals/totals.duck'
import {select_gridSession_filtersOptions_raveUrl} from 'redux/totals/selectors'
import {select_gridSession_filters} from 'redux/totals/selectors'
import {FilterSelect} from '@mdsol/onex-design'
import {getSelectedFilterOptions, getSelectedRaveUrlFilterOptions} from 'helpers/jobs'
import _isEqual from 'lodash.isequal'
import {FiltersType} from 'redux/totals/state'
import {JobStatusType} from 'commonTypes'
import {JobStatus} from 'graphql-api'

import './filtersPanel.scss'

const FiltersPanel: FC = () => {
  const dispatch = useAppDispatch()
  const router = useRouter()

  const selectedFilters = useSelector(select_gridSession_filters)
  const {
    jobStatus: selectedJobStatusFilters,
    databaseId: selectedRaveUrlFilters,
  } = selectedFilters

  const jobStatusOptions = getSelectedFilterOptions(Object.values(JobStatus) as [JobStatusType])
  const raveUrlOptions = useSelector(select_gridSession_filtersOptions_raveUrl)

  const handleApplyFilters = (filters: FiltersType) => {
    dispatch(TotalsAC.homeStatsReset())
    dispatch(refreshHomeStats(router, filters))
  }

  const handleRaveUrlFilterChange = selectedRaveUrlOptions => {
    const raveUrlFilters = selectedRaveUrlOptions.map(selectedRaveUrlOption => selectedRaveUrlOption.value)

    const haveRaveUrlFiltersChanged = !_isEqual([...raveUrlFilters].sort(), [...selectedRaveUrlFilters].sort())
    if (haveRaveUrlFiltersChanged) {
      handleApplyFilters({
        ...selectedFilters,
        databaseId: raveUrlFilters,
      })
    }
  }

  const  handleJobStatusFilterChange = selectedJobStatusOptions => {
    const jobStatusFilters = selectedJobStatusOptions.map(selectedJobStatusOption => selectedJobStatusOption.value)

    const haveJobStatusFiltersChanged = !_isEqual([...jobStatusFilters].sort(), [...selectedJobStatusFilters].sort())
    if (haveJobStatusFiltersChanged) {
      handleApplyFilters({
        ...selectedFilters,
        jobStatus: jobStatusFilters,
      })
    }
  }

  return (
    <div id='home-stats-filters-panel' className='onex-data-grid-filters'>
      <div className='onex-data-grid-filters-container'>
        <div className='onex-data-grid-filters-wrapper'>
          <FilterSelect
            dataTestId='rave-url-filter'
            label='Url'
            isMulti
            isSearchable
            selectAll
            selectAllLabel='All Urls'
            displayApplyButton={false}
            value={getSelectedRaveUrlFilterOptions(selectedRaveUrlFilters, raveUrlOptions)}
            options={raveUrlOptions}
            onChange={handleRaveUrlFilterChange}
          />
        </div>

        <div className='onex-data-grid-filters-wrapper'>
          <FilterSelect
            dataTestId='job-status-filter'
            label='Job Status'
            isMulti
            selectAll
            selectAllLabel='All Job Statuses'
            displayApplyButton={false}
            value={getSelectedFilterOptions(selectedJobStatusFilters)}
            options={jobStatusOptions}
            onChange={handleJobStatusFilterChange}
            isSearchable={false}
          />
        </div>
      </div>
    </div>
  )
}

export default FiltersPanel
